import * as Yup from 'yup';
import {FormikValues} from 'formik';
import {LanguageId} from '../../../models/utils/Languages';
import {SectionId} from '../../../models/form/types';
import FieldConfiguration, {TranslatedWord} from '../../../models/form/FieldConfiguration';
import SimpleFormCompanion from './SimpleFormCompanion';
import OptionsLanguageManager from './OptionsLanguageManager';
import {TranslatedOptionsQL} from '../../../models/graphql/TranslatedOptionsQL';
import {FormTypeContextData} from '../types';

export default class DropdownFormCompanion extends SimpleFormCompanion {
  readonly optionsManager: OptionsLanguageManager

  constructor(
    protected readonly sectionId: SectionId | undefined,
    protected readonly translations: LanguageId[],
    protected readonly formTypeContext: FormTypeContextData,
    readonly configuration?: FieldConfiguration,
  ) {
    super(sectionId, translations, formTypeContext, configuration);
    this.optionsManager = new OptionsLanguageManager(this.translations, this.configuration);
  }

  prepareInput(values: FormikValues) {
    const labels: TranslatedWord[] = [];
    const options: TranslatedOptionsQL[] = [];
    Object.entries(values).forEach((entry) => {
      const [key, value] = entry;
      if (this.translations.indexOf(key) >= 0) {
        labels.push({language: key, translation: value});
      }
      if (key.startsWith('options_')) {
        const langId = key.split('_')[1];
        if (this.translations.indexOf(langId) >= 0) {
          options.push({language: langId, translations: value});
        }
      }
    });
    if (this.configuration) {
      return {
        data: {
          labels,
          label: values.label,
          sectionId: this.configuration.field.sectionId,
          options,
        },
        type: 'EvaluationFormType',
        id: this.configuration.id,
      };
    }
    return {
      data: {
        labels, label: values.label, sectionId: this.sectionId, options,
      },
      type: 'EvaluationFormType',
    };
  }

  getInitialFormValues(): Record<string, unknown> {
    return Object.assign(
      {label: this.configuration?.field.label || ''},
      this.labelManager.initialFormValues(),
      this.optionsManager.initialFormValues(),
    );
  }

  getValidationObject() {
    const schema = Object.assign(
      {label: Yup.string().min(1, 'Must not be empty').required('Required')},
      this.labelManager.validationObject(),
      this.optionsManager.validationObject(),
    );
    return Yup.object(schema);
  }
}
